/**
 * Returns a string with escaped double quotes
 * @param value {string}
 * @returns {string}
 */
const escapeValue = value => '"' + String.prototype.replace.call(value, /"/g, '\\"') + '"';

export {escapeValue};
